
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  background?: 'white' | 'light';
  hover?: boolean;
}

export default function Card({
  children,
  className = '',
  background = 'white',
  hover = false,
}: CardProps) {
  const baseClasses = 'rounded-2xl shadow-sm transition-all duration-200';
  const backgroundClasses = {
    white: 'bg-white',
    light: 'bg-[#F6F8FA]',
  };
  const hoverClasses = hover ? 'hover:shadow-md hover:-translate-y-1' : '';
  
  return (
    <div className={`${baseClasses} ${backgroundClasses[background]} ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
}
